export default __webpack_public_path__ + "static/media/logo-white.ced7045b.png";